"use client";

import { communitiesAdminFlaggableSchema } from "../../../../../lib/types/schema/community/admin/communitiesAdminFlaggableSchema";
import type { UseRequestQueryProps } from "../../../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../../../request/hooks/useRequestQuery";
import { keyCommunitiesAdminFlaggable } from "./keyCommunitiesAdminFlaggable";

export type UseRequestCommunitiesAdminFlaggableProps = UseRequestQueryProps & {
  id: number;
};

export const useRequestCommunitiesAdminFlaggable = ({
  id,
  staleTime,
  ...props
}: UseRequestCommunitiesAdminFlaggableProps) => ({
  query: useRequestQuery({
    enabledWithoutSessionToken: false,
    staleTime,
    ...props,
    queryFnRequestProps: {
      schema: communitiesAdminFlaggableSchema,
      urlBackendPath: `/moderation/communities/${id}`,
    },
    queryKey: keyCommunitiesAdminFlaggable({
      hasStaleTime: staleTime ? true : false,
      id,
    }),
  }),
});
